import { createAction } from 'redux-actions';

export const SET_USER = 'SET_USER';
export const setUser = createAction(SET_USER);
